<app-page-header title="PSP Error Code" subtitle="Manage error codes and messages for payment providers">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        [value]="errorCodes"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['code', 'error', 'message', 'pspType']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="text-left w-[80px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="code" class="text-left">
                    <div class="flex items-center gap-2">
                        Code
                        <p-sortIcon field="code"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="code" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="error" class="text-left">
                    <div class="flex items-center gap-2">
                        Error
                        <p-sortIcon field="error"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="error" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="message" class="text-left">
                    <div class="flex items-center gap-2">
                        Message
                        <p-sortIcon field="message"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="message" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="pspType" class="text-left">
                    <div class="flex items-center gap-2">
                        PSP Type
                        <p-sortIcon field="pspType"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="pspType" display="menu"></app-column-filter>
                    </div>
                </th>
                <th class="w-[80px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.code }}</td>
                <td>{{ row.error }}</td>
                <td>{{ row.message }}</td>
                <td>{{ row.pspType }}</td>
                <td class="text-right">
                    <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [header]="isEditMode ? 'Edit Error Code' : 'New Error Code'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '500px' }"
>
    <form [formGroup]="errorCodeForm" (ngSubmit)="saveErrorCode()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Code *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter error code"
                    formControlName="code"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('code') }"
                />
                @if (isInvalid('code')) {
                    <small class="text-red-500">Code is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Error *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter error name"
                    formControlName="error"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('error') }"
                />
                @if (isInvalid('error')) {
                    <small class="text-red-500">Error is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Message *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter error message"
                    formControlName="message"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('message') }"
                />
                @if (isInvalid('message')) {
                    <small class="text-red-500">Message is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">PSP Type *</label>
                <p-select
                    [options]="pspTypes"
                    formControlName="pspTypeId"
                    optionLabel="text"
                    optionValue="id"
                    placeholder="Select PSP type"
                    [filter]="true"
                    filterBy="text"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('pspTypeId') }"
                ></p-select>
                @if (isInvalid('pspTypeId')) {
                    <small class="text-red-500">PSP type is required.</small>
                }
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="saveErrorCode()"></p-button>
        </div>
    </ng-template>
</p-dialog>
